import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { getAppDomainOptions } from '@/api/system/appDomain'
import type { AppDomainOption } from '@/types/appDomain'

interface AppDomainState {
  /** 当前管理员可选的 APP 域名；绑定了域名的管理员只有其绑定域名。 */
  options: AppDomainOption[]
  /** 右上角选中的域名 id，null 即「全部」。随请求头 X-App-Domain-Id 发给后端。 */
  selectedId: string | null
  /** 「按 APP 域名区分」开关当前是否打开。 */
  partitionEnabled: boolean
  loaded: boolean
}

interface AppDomainActions {
  fetchOptions(): Promise<void>
  select(id: string | null): void
  reset(): void
}

const useAppDomainStore = create<AppDomainState & AppDomainActions>()(
  persist(
    (set, get) => ({
      options: [],
      selectedId: null,
      partitionEnabled: false,
      loaded: false,

      async fetchOptions() {
        try {
          const { items, partition_enabled } = await getAppDomainOptions()
          const { selectedId } = get()
          set({
            options: items,
            partitionEnabled: !!partition_enabled,
            loaded: true,
            // 选中的域名被删掉后继续带着它请求，后端会对每个接口报「域名不存在」。
            selectedId: items.some((d) => d.id === selectedId) ? selectedId : null,
          })
        } catch (err) {
          console.warn('[appDomain] fetchOptions failed:', err)
        }
      },

      select(id) {
        set({ selectedId: id })
      },

      reset() {
        set({ options: [], selectedId: null, partitionEnabled: false, loaded: false })
      },
    }),
    {
      name: 'app-domain-storage',
      partialize: (state) => ({ selectedId: state.selectedId }),
    }
  )
)

export default useAppDomainStore
